export const TRACK_RESOLUTION_CACHE_INVALIDATED_EVENT =
  'routecamp-track-resolution-cache-invalidated'

export function invalidateTrackResolutionCaches() {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent(TRACK_RESOLUTION_CACHE_INVALIDATED_EVENT))
}
